import React from 'react'
import { Row, Col, Tooltip } from 'antd'
import './index.less'
import {reviewState} from '../../../../utils/global'

export default class ImageMode extends React.Component {
	state = {

	}
	render() {
		const { dataSource, idMap } = this.props
		return (
			<Row className="show-content-list">
				{
					dataSource.map(item => {
						return (
							<Col span={4} className="show-content-item" key={item.id}>
								<div className="show-content-inner">
									<div className="content-area">
										<div className="title" onClick={() => this.props.getDetails(item.id, 1)}>{item.st_text_title}</div>
										<span
											className="play-btn"
											onClick={() => this.props.handlePreview({content: item.st_fileurl || item.st_text_content, type: idMap[item.st_type]}, item)}>
										</span>
										<div className="content-main">
											{
												JSON.stringify(idMap) !== '{}' ?
													idMap[item.st_type] === '图片' ?
														<img src={item.st_fileurl}/>
														:
														idMap[item.st_type] === '视频' && (item.st_fileurl.includes('.mp4') || item.st_fileurl.includes('.MP4')) ?
															<video src={item.st_fileurl}/>
															:
															idMap[item.st_type] === '视频' && !item.st_fileurl.includes('.mp4') ?
																<div className="default-show video-image"></div>
																:
																idMap[item.st_type] === '音频' ?
																	<div className="default-show music-image"></div>
																	:
																	<div className="default-show text-image"></div>
													:
													''
											}
										</div>
									</div>
									<div className="handle-area">
										<Tooltip placement="top" title={idMap[item.st_type]}>
											<span
												className={`icon type ${idMap[item.st_type] === '视频' ? 'icon-video' : idMap[item.st_type] === '音频' ? 'icon-music' : idMap[item.st_type] === '图片' ? 'icon-image' : 'icon-text'}`}>
											</span>
										</Tooltip>
										<span className="icon del" onClick={() => this.props.del(item.id)}></span>
										<span className="icon edit" onClick={() => this.props.update(item)}></span>
										<span
											onClick={() => this.props.batchReview(item.id, reviewState[item.st_review])}
											className={`check-state ${reviewState[item.st_review] ? reviewState[item.st_review] === '未审核' ? 'cdc-warning' : reviewState[item.st_review] === '未通过' ? 'cdc-danger' : 'cdc-success' : 'cdc-warning'}`}
										>
											{reviewState[item.st_review] ? reviewState[item.st_review] : '未审核'}
										</span>
									</div>
								</div>
							</Col>
						)
					})
				}
			</Row>
		)
	}
}